import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TryLocalizePipe } from './try-localize.pipe';

@NgModule({
  declarations: [TryLocalizePipe],
  imports: [CommonModule],
  exports: [TryLocalizePipe]
})
export class TryLocalizeModule {}
